import React, {
	Component,
} from 'react';
import moment from 'moment';

import LastCheckTimestampBuilder, {
	LastCheckTimestampCrawlingType,
	LastCheckTimestampSize,
} from '~/components/patterns/time/LastCheckTimestamp';



const ANIMATION_TIMEOUT = 2000;

class LastCheckTimestamp extends Component {

	constructor(props, context) {
		super(props, context);

		this.timer = null;

		if (this.props.setCheckingNowHintCallback) {
			this.props.setCheckingNowHintCallback(true);
		}

		this.state = {
			iconSpinning: true,
			spinInfinite: true,
		};
	}



	componentWillUnmount() {
		clearTimeout(this.timer);
	}



	UNSAFE_componentWillReceiveProps(nextProps) {
		const {
			lastTimeCheckedAt,
			setCheckingNowHintCallback,
			timestamp,
			windowHasFocus,
		} = this.props;

		const {
			lastTimeCheckedAt: nextLastTimeCheckedAt,
			timestamp: nextTimestamp,
			windowHasFocus: nextWindowHasFocus,
		} = nextProps;

		const {
			spinInfinite,
		} = this.state;

		if (
			!spinInfinite
			&& moment.isMoment(timestamp)
			&& moment.isMoment(nextTimestamp)
			&& !timestamp.isSame(nextTimestamp)
		) {
			this.setState({
				iconSpinning: true,
			}, () => {
				clearTimeout(this.timer);

				this.timer = setTimeout(() => {
					this.setState({
						iconSpinning: false,
					});
				}, ANIMATION_TIMEOUT);
			});
		} else if (
			!spinInfinite
			&& timestamp instanceof Date
			&& nextTimestamp instanceof Date
			&& timestamp !== nextTimestamp
		) {
			this.setState({
				iconSpinning: true,
			}, () => {
				clearTimeout(this.timer);

				this.timer = setTimeout(() => {
					this.setState({
						iconSpinning: false,
					});
				}, ANIMATION_TIMEOUT);
			});
		}

		if (spinInfinite && lastTimeCheckedAt !== undefined && lastTimeCheckedAt !== nextLastTimeCheckedAt) {
			if (setCheckingNowHintCallback) {
				setCheckingNowHintCallback(false);
			}

			this.setState({
				spinInfinite: false,
				iconSpinning: false,
			});
		}

		if (!windowHasFocus && nextWindowHasFocus) {
			if (setCheckingNowHintCallback) {
				setCheckingNowHintCallback(true);
			}

			clearTimeout(this.timer);
			this.setState({
				spinInfinite: true,
				iconSpinning: true,
			});
		}
	}



	render() {
		const {
			checkedAtLabel,
			explanationMessage,
			isPaused,
		} = this.props;

		const {
			iconSpinning,
			spinInfinite,
		} = this.state;

		let crawlingType;

		if (iconSpinning && spinInfinite) {
			crawlingType = LastCheckTimestampCrawlingType.InProgress;
		} else if (iconSpinning && !spinInfinite) {
			crawlingType = LastCheckTimestampCrawlingType.JustFinished;
		} else {
			crawlingType = LastCheckTimestampCrawlingType.Ready;
		}

		return (
			<LastCheckTimestampBuilder
				checkedAtLabel={checkedAtLabel}
				crawlingType={crawlingType}
				explanationMessage={explanationMessage}
				isCrawlingPaused={isPaused}
				size={LastCheckTimestampSize.Small}
			/>
		);
	}

}



export default LastCheckTimestamp;
